import React from 'react';

export const TagsContext = React.createContext({
  data: null,
  loading: false,
  fetch: () => {},
});

export default TagsContext;